jQuery(function(){
  comp_calc();
});

function comp_calc(){
  if( !jQuery('.comp_calc').length ){
  return;
}
  var compCalc = jQuery('.comp_calc');


var hash = window.location.hash;
if( hash == '#kalkulacka' ){
      compCalc.toggleClass('open');
}

  compCalc.find('input[name="price"]').parents('.item').find('.value strong').html(number_format(compCalc.find('input[name="price"]').val(), 0, ',', ' '));



  compCalc.find('.close-trigger, .close_text-trigger').on('click',function(event){
      event.preventDefault();
      compCalc.removeClass('open');
  });

  jQuery('.comp_calc-open_from_menu-trigger a').on('click',function(event){
      event.preventDefault();
      compCalc.addClass('open');
  if( jQuery('header.main_header-wrapper .menu-wrapper').is(':visible') ){
    jQuery('header.main_header-wrapper .menu-wrapper').stop(true,true).slideUp(400);
    jQuery('.mobile-menu-trigger').removeClass('is-active');
  }
  });
  jQuery('.comp_calc-open-trigger').on('click',function(event){
      event.preventDefault();
      compCalc.toggleClass('open');
  });

  // init sliders
  compCalc.find('.input-rangeslider').rangeslider({
  polyfill : false,
  onInit: function() {
    // console.log(jQuery(this));
    //console.log(jQuery(this.$element).data('handler_class'));
    //console.log(jQuery(this.$handle));
    rangeSliderCalc( this );
  },
  onSlide: function(position, value) {
    // console.log(jQuery(this));
    rangeSliderCalc( this );


  }
  });


  compCalc.find('.slider-button').on('click',function(event){
      event.preventDefault();

      var elThis = jQuery(this);

      var elInput = elThis.parents('.item').find('input');
      var elInputVal = parseFloat( elInput.val() );
      var step = parseFloat( elInput.data('step_move') );

      if( elThis.data('type') == 'plus' ){
          // if( elInputVal == 1000 ){
          //     var newVal = 10000;
          // }else{
          //     var newVal = elInputVal + step;
          // }
          var newVal = elInputVal + step;
      }else{
          var newVal = elInputVal - step;
      }

      elInput.val(newVal).change();
  });




}





function rangeSliderCalc( el ){

var elThis = jQuery(el.$element);
var elHandle = jQuery(el.$handle);
var elWrapper = elThis.parents('.comp_calc');
var currentValue = elThis.val();
var price = parseInt( elWrapper.find('input[name="price"]').val() );

  var decimals = 0;
  if( elThis.prop('name') == 'interest' ){
      decimals = 1;
  }

  elThis.parents('.item').find('.value strong').html(number_format(currentValue, decimals, ',', ' '));



var interest = parseFloat( elWrapper.find('input[name="interest"]').val() );
interest = interest / 100;

var maturityMonths = parseInt( elWrapper.find('input[name="lenght"]').val() );
var netEarnings = price * interest / 12 * maturityMonths;

  // if( price >= 20000 ){
  //     netEarnings += 1000;
  // }


elWrapper.find('.total .value span').html( number_format(netEarnings, 0, ',', ' ') );

}

function number_format(number, decimals, dec_point, thousands_sep){
  // http://kevin.vanzonneveld.net
  // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +     bugfix by: Michael White (http://getsprink.com)
  // +     bugfix by: Benjamin Lupton
  // +     bugfix by: Allan Jensen (http://www.winternet.no)
  // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +     bugfix by: Howard Yeend
  // +    revised by: Luke Smith (http://lucassmith.name)
  // +     bugfix by: Diogo Resende
  // +     bugfix by: Rival
  // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
  // +   improved by: davook
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Jay Klehr
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Amir Habibi (http://www.residence-mixte.com/)
  // +     bugfix by: Brett Zamir (http://brett-zamir.me)
  // +   improved by: Theriault
  // +      input by: Amirouche
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // *     example 1: number_format(1234.56);
  // *     returns 1: '1,235'
  // *     example 2: number_format(1234.56, 2, ',', ' ');
  // *     returns 2: '1 234,56'
  // *     example 3: number_format(1234.5678, 2, '.', '');
  // *     returns 3: '1234.57'
  // *     example 4: number_format(67, 2, ',', '.');
  // *     returns 4: '67,00'
  // *     example 5: number_format(1000);
  // *     returns 5: '1,000'
  // *     example 6: number_format(67.311, 2);
  // *     returns 6: '67.31'
  // *     example 7: number_format(1000.55, 1);
  // *     returns 7: '1,000.6'
  // *     example 8: number_format(67000, 5, ',', '.');
  // *     returns 8: '67.000,00000'
  // *     example 9: number_format(0.9, 0);
  // *     returns 9: '1'
  // *    example 10: number_format('1.20', 2);
  // *    returns 10: '1.20'
  // *    example 11: number_format('1.20', 4);
  // *    returns 11: '1.2000'
  // *    example 12: number_format('1.2000', 3);
  // *    returns 12: '1.200'
  // *    example 13: number_format('1 000,50', 2, '.', ' ');
  // *    returns 13: '100 050.00'
  // Strip all characters but numerical ones.
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}


